import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface CardsReducer {
    hasGold: boolean;
    hasBusiness: boolean;
    hasCards: boolean;
    hasAllCardsOtherBank: boolean;
    hasCardOtherBank: boolean;
    hasInvalidCards: boolean; // TODO: Fra SDC -> ErrorMessage
    canHaveGold: boolean;
    canHaveBusiness: boolean;
    supportedCards: any;
    selectedCard: {
        hasCard: boolean;
    };
    goldCard: any;
    businessCard: any;
    paramType: string;
    paramIncrease: boolean | null;
    korttype: string;
    kortId: string;
    blockedGoldCard: boolean;
    blockedBusinessCard: boolean;
}

export const initialState: CardsReducer = {
    hasGold: false,
    hasBusiness: false,
    hasCards: false,
    hasAllCardsOtherBank: false,
    hasCardOtherBank: false,
    hasInvalidCards: false,
    canHaveGold: false,
    canHaveBusiness: false,
    supportedCards: {},
    selectedCard: {
        hasCard: false,
    },
    goldCard: {},
    businessCard: {},
    paramType: '',
    paramIncrease: null,
    korttype: '',
    kortId: '',
    blockedGoldCard: false,
    blockedBusinessCard: false,
};

export const cardsReducer = (state = initialState, action: AppActions = {} as AppActions): CardsReducer => {
    switch (action.type) {
        case actionTypes.FETCH_CARDS_FULFILLED: {
            const {
                alleKortprodukter,
                eksisterendeKort,
                harUgyldigeKort,
                tilgjengeligeKort,
                kortIAndreLokalbanker,
                blockedCards,
                // blockIncreaseCards,
            } = action.payload;

            if (harUgyldigeKort) {
                return {
                    ...state,
                    hasInvalidCards: harUgyldigeKort,
                };
            }

            // const goldBlocked = blockIncreaseCards.find((card: any) => card.produkt.gruppe === 'GOLD');
            // const businessBlocked = blockIncreaseCards.find((card: any) => card.produkt.gruppe === 'BUSINESS');
            const goldcard = eksisterendeKort.find((card: any) => card.produkt.gruppe === 'GOLD') || state.goldCard;
            const businesscard =
                eksisterendeKort.find((card: any) => card.produkt.gruppe === 'BUSINESS') || state.businessCard;

            const blockedGoldCard = Boolean(
                blockedCards.find((card: any) => card.kontonummer === goldcard.kontonummer),
            );
            const blockedBusinessCard = Boolean(
                blockedCards.find((card: any) => card.kontonummer === businesscard.kontonummer),
            );

            /* Get Supported Card Types */
            const { cardTypeGold, cardTypeBusiness } = alleKortprodukter.reduce((ret: any, it: any) => {
                if (it.gruppe === 'GOLD') ret.cardTypeGold = it.kode;
                if (it.gruppe === 'BUSINESS') ret.cardTypeBusiness = it.kode;
                return ret;
            }, {});

            const canHaveGold = Boolean(tilgjengeligeKort.find((card: any) => card.gruppe === 'GOLD'));
            const canHaveBusiness = Boolean(tilgjengeligeKort.find((card: any) => card.gruppe === 'BUSINESS'));
            const hasGold = Boolean(eksisterendeKort.find((card: any) => card.produkt.gruppe === 'GOLD'));
            const hasBusiness = Boolean(eksisterendeKort.find((card: any) => card.produkt.gruppe === 'BUSINESS'));

            return {
                ...state,
                hasAllCardsOtherBank: !canHaveGold && !hasGold && !canHaveBusiness && !hasBusiness,
                hasCardOtherBank: !!kortIAndreLokalbanker && kortIAndreLokalbanker.length > 0 && true,
                hasInvalidCards: harUgyldigeKort,
                hasCards: !!eksisterendeKort && eksisterendeKort.length > 0 && true,
                hasGold,
                hasBusiness,
                supportedCards: {
                    gold: cardTypeGold,
                    business: cardTypeBusiness,
                },
                canHaveGold,
                canHaveBusiness,
                goldCard: eksisterendeKort.find((card: any) => card.produkt.gruppe === 'GOLD') || state.goldCard,
                businessCard:
                    eksisterendeKort.find((card: any) => card.produkt.gruppe === 'BUSINESS') || state.businessCard,
                blockedGoldCard,
                blockedBusinessCard,
            };
        }

        /* Populate selectedCard when status has card info. */
        case actionTypes.FETCH_STATUS_FULFILLED: {
            const { kort } = action.payload.response;

            if (kort) {
                /* Since web-back-end dont return this info on 'status' response, we need to add it from 'kort' response for now... */
                let selectedCardObject = {};
                if (kort.produkt.gruppe && kort.produkt.gruppe === 'GOLD') {
                    selectedCardObject = {
                        ...state.goldCard,
                    };
                } else if (kort.produkt.gruppe && kort.produkt.gruppe === 'BUSINESS') {
                    selectedCardObject = {
                        ...state.businessCard,
                    };
                }
                return {
                    ...state,
                    kortId: kort.kontonummer ? String(kort.kontonummer) : state.kortId,
                    korttype: kort.produkt.kode || state.korttype,
                    paramType: kort.produkt.gruppe === 'BUSINESS' ? 'business' : state.paramType, // Define business group
                    selectedCard: {
                        ...state.selectedCard,
                        ...selectedCardObject,
                        hasCard: !!kort.kontonummer,
                    },
                };
            }
            return state;
        }

        case actionTypes.FETCH_CASE_FULFILLED: {
            const { kort } = action.payload;

            if (kort) {
                let selectedCardObject = {};
                if (kort.produkt.gruppe && kort.produkt.gruppe === 'GOLD') {
                    selectedCardObject = {
                        ...state.goldCard,
                    };
                } else if (kort.produkt.gruppe && kort.produkt.gruppe === 'BUSINESS') {
                    selectedCardObject = {
                        ...state.businessCard,
                    };
                }
                return {
                    ...state,
                    kortId: kort.kontonummer ? String(kort.kontonummer) : state.kortId,
                    korttype: kort.produkt.kode || state.korttype,
                    paramType: kort.produkt.gruppe === 'BUSINESS' ? 'business' : state.paramType, // Define business group
                    selectedCard: {
                        ...state.selectedCard,
                        ...selectedCardObject,
                        hasCard: !!kort.kontonummer,
                    },
                };
            }
            return state;
        }

        case actionTypes.FETCH_AGRI_MEMBER_FULFILLED: {
            const { kortType } = action.payload;
            const { supportedCards, goldCard, businessCard, hasCards, hasBusiness, hasGold } = state;

            if (kortType && kortType.length > 0) {
                let cardId;
                let cardType;

                if (kortType === 'ANSATT') {
                    cardId = hasBusiness ? businessCard.kontonummer : state.kortId;
                    cardType = supportedCards.business || state.korttype;
                } else {
                    cardId = hasGold ? goldCard.kontonummer : state.kortId;
                    cardType = supportedCards.gold || state.korttype;
                }

                if (hasCards) {
                    return {
                        ...state,
                        canHaveGold: kortType === 'PRIVAT' || kortType === 'ANSATT',
                        canHaveBusiness: kortType === 'ANSATT',
                    };
                }

                return {
                    ...state,
                    canHaveGold: kortType === 'PRIVAT' || kortType === 'ANSATT',
                    canHaveBusiness: kortType === 'ANSATT',
                    paramType: kortType === 'ANSATT' ? 'business' : state.paramType,
                    korttype: cardType,
                    kortId: cardId || state.kortId,
                };
            }
            return state;
        }

        /* Update State from Params */
        case actionTypes.PARAM_STATE_UPDATE: {
            const { type, endre } = action.payload;
            const { supportedCards, hasGold, hasBusiness, goldCard, businessCard } = state;

            let hasCard;
            let selectedCardObject = {};
            let cardId;
            let cardType;

            if (type && type === 'business') {
                cardType = (supportedCards && supportedCards.business) || state.korttype;
                cardId = hasBusiness ? businessCard.kontonummer : state.kortId;
                hasCard = hasBusiness && !!businessCard.kontonummer;
                selectedCardObject = {
                    ...state.businessCard,
                };
            } else {
                cardType = supportedCards.gold;
                cardId = hasGold ? goldCard.kontonummer : state.kortId;
                hasCard = hasGold && !!goldCard.kontonummer;
                selectedCardObject = {
                    ...state.goldCard,
                };
            }
            const paramIncrease = !!parseInt(endre, 10);

            return {
                ...state,
                korttype: cardType,
                kortId: cardId,
                paramType: type,
                paramIncrease,
                selectedCard: {
                    ...state.selectedCard,
                    ...selectedCardObject,
                    hasCard,
                },
            };
        }

        default:
            return state;
    }
};
